import { render, staticRenderFns } from "./MRegisterInfoEdit.vue?vue&type=template&id=4c32ed7d&scoped=true&"
import script from "./MRegisterInfoEdit.vue?vue&type=script&lang=ts&"
export * from "./MRegisterInfoEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MRegisterInfoEdit.vue?vue&type=style&index=0&id=4c32ed7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32ed7d",
  null
  
)

export default component.exports